module.exports = Promise.resolve(module.bundle.root("j1W5C"))